<template>
    <div class="container">
        <button @click="FrameworkClicked">Download Dr. Oliver's Framework</button>
    </div>
</template>

<script>

import { useRouter  } from 'vue-router';


export default {
    "name": "home-section-2",
    setup() {
        const router = useRouter();

        function FrameworkClicked(){
            router.push('/Framework');
        }

        return{
            FrameworkClicked
        }

    },
}
</script>

<style lang="scss" scoped>
@import '@/styles/shared.scss';

.container{
    display: flex; 
    justify-content: center; 
    align-items: center;
    margin-top: 5%;
    margin-bottom: 75px;


}

 button{
     cursor: pointer;
        color: white;
        min-width: 100px;
        min-height: 50px;
        background: #662d91;
        padding: 1%;
        border-radius: 5px;
        font-size: 1rem;
        -webkit-box-shadow: 0 8px 6px -6px black;
        -moz-box-shadow: 0 8px 6px -6px black;
        box-shadow: 0 8px 6px -6px black;
}

button:hover{
    background-color: grey;
}



</style>